/* eslint-disable no-unused-vars */

import $ from './jquery-3.3.1.min.js'
let bgColor = '#000000'// 背景
const upColor = '#FF6060'// 涨颜色
const downColor = '#00FFFF'// 跌颜色
let lastColor = '#ff0000'// 昨结
let lineColor = '#fff'
let xyAxisColor = '#FF0000' // xy轴线颜色
// ma  颜色
const ma5Color = '#888800'
const ma10Color = '#da6ee8'
const ma20Color = '#ffab42'
const ma30Color = '#00940b'

/**
 * 15:20 时:分 格式时间增加num分钟
 * @param {Object} time 起始时间
 * @param {Object} num
 */
function addTimeStr(time, num) {
  let hour = time.split(':')[0]
  let mins = Number(time.split(':')[1])
  const mins_un = parseInt((mins + num) / 60)
  const hour_un = parseInt((Number(hour) + mins_un) / 24)
  if (mins_un > 0) {
    if (hour_un > 0) {
      const tmpVal = ((Number(hour) + mins_un) % 24) + ''
      hour = tmpVal.length > 1 ? tmpVal : '0' + tmpVal// 判断是否是一位
    } else {
      const tmpVal = Number(hour) + mins_un + ''
      hour = tmpVal.length > 1 ? tmpVal : '0' + tmpVal
    }
    const tmpMinsVal = ((mins + num) % 60) + ''
    mins = tmpMinsVal.length > 1 ? tmpMinsVal : 0 + tmpMinsVal// 分钟数为 取余60的数
  } else {
    const tmpMinsVal = mins + num + ''
    mins = tmpMinsVal.length > 1 ? tmpMinsVal : '0' + tmpMinsVal// 不大于整除60
  }
  return hour + ':' + mins
}

// 获取增加指定分钟数的 数组  如 09:30增加2分钟  结果为 ['09:31','09:32']
function getNextTime(startTime, endTIme, offset, resultArr) {
  const result = addTimeStr(startTime, offset)
  resultArr.push(result)
  if (result == endTIme) {
    return resultArr
  } else {
    return getNextTime(result, endTIme, offset, resultArr)
  }
}

/**
 * 不同类型的股票的交易时间会不同
 * @param {Object} type   hs=沪深  us=美股  hk=港股 dd=订单
 */
const time_arr = function(type) {
  if (type.indexOf('us') != -1) { // 生成美股时间段
    const timeArr = []
    timeArr.push('09:30')
    return getNextTime('09:30', '16:00', 1, timeArr)
  }
  if (type.indexOf('hs') != -1) { // 生成沪深时间段
    const timeArr = []
    timeArr.push('09:30')
    timeArr.concat(getNextTime('09:30', '11:29', 1, timeArr))
    timeArr.push('13:00')
    timeArr.concat(getNextTime('13:00', '15:00', 1, timeArr))
    return timeArr
  }
  if (type.indexOf('hk') != -1) { // 生成港股时间段
    const timeArr = []
    timeArr.push('09:30')
    timeArr.concat(getNextTime('09:30', '11:59', 1, timeArr))
    timeArr.push('13:00')
    timeArr.concat(getNextTime('13:00', '16:00', 1, timeArr))
    return timeArr
  }
  if (type.indexOf('dd') != -1) { // 生成订单交易时间段
    const timeArr = []
    timeArr.push('09:00')
    timeArr.concat(getNextTime('09:00', '11:29', 1, timeArr))
    timeArr.push('13:00')
    timeArr.concat(getNextTime('13:00', '15:30', 1, timeArr))
    return timeArr
  }
}

const formatDate = function(timestamp) {
  const date = new Date(Number(timestamp))
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hour = date.getHours()
  let min = date.getMinutes()
  let sec = date.getSeconds();
  [year, month, day, hour, min, sec] = [year, month, day, hour, min, sec].map(
    item => (item < 10 ? '0' + item : item)
  )
  return `${year}-${month}-${day} ${hour}:${min}`
}

const get_m_data = function(m_data, type, low, high) {
  // 取最大最小价格值
  let lastPrice1 = Number(m_data.yestclose)
  // 处理返回数据错误的情况
  if (lastPrice1 === 0) {
    lastPrice1 = (Number(high) + Number(low)) / 2
  }
  let priceMax = 0; let priceMin = m_data?.data && m_data.data.length > 0 ? m_data.data[0][1] : 0
  for (const i in m_data.data) {
    if (Number(m_data.data[i][1]) && Number(m_data.data[i][1]) > priceMax) {
      priceMax = Number(m_data.data[i][1])
    }
    if (Number(m_data.data[i][1]) && Number(m_data.data[i][1]) < priceMin) {
      priceMin = Number(m_data.data[i][1])
    }
  }
  // 重新计算价格的最大最小值，以达到对称的效果
  if ((lastPrice1 - priceMax) * -1 > (lastPrice1 - priceMin)) {
    priceMin = (lastPrice1 - ((lastPrice1 - priceMax) * -1))
  } else {
    priceMax = (lastPrice1 + (lastPrice1 - priceMin))
  }
  // 处理无交易情况,添加y轴范围
  if (Number(priceMin) === Number(priceMax) || Number(priceMin) === 0) {
    if (low && Number(low) !== 0 && high && Number(high) !== 0) {
      priceMin = Number(low)
      priceMax = Number(high)
    } else {
      priceMin = Number(lastPrice1) - 10
      priceMax = Number(lastPrice1) + 10
    }
    if (Number(low) && Number(priceMin) < Number(low)) {
      priceMin = Number(low)
    }
    if (Number(high) && Number(priceMax) > Number(high)) {
      priceMax = Number(high)
    }
  }
  const priceArr = []
  const lastPrice = []
  const vol = []
  // let times = time_arr(type)
  const times = []
  const datatype = []
  const avgPrice = []
  const index = []
  const barVolume = []
  const barVolumeOffZero = []
  let startIndex = 0
  $.each(m_data.data, function(i, v) {
    const timeStr = formatDate(v[0])
    times.push(timeStr)
    priceArr.push(v[1] ? v[1] : '')
    lastPrice.push(v[2] ? v[2] : '')
    vol.push(v[3] ? v[3] : '')
    avgPrice.push(v[4] ? v[4] : '')
    datatype.push(v[5] ? v[5] : '')
    // avgPrice.push('1215')
    if (v[5] === '0') {
      startIndex++
    }
    index.push(i)
    // // 交易节变动部分的红线设置
    // /**
    //  * 交易节：
    //  晚上19:00-21:00
    // 上午9:30-11:30
    // 下午1:30-16:00
    //  */
    // if (timeStr.indexOf('13:30') > -1 || timeStr.indexOf('09:30') > -1 || timeStr.indexOf('19:00') > -1) {
    // // if (timeStr.indexOf('13:00') > -1 || timeStr.indexOf('09:00') > -1) {
    //   barVolume.push(priceMax)
    //   barVolumeOffZero.push(priceMin)
    // } else {
    //   barVolume.push(priceMin < 0 ? 0 : priceMin)
    //   barVolumeOffZero.push(priceMin < 0 ? 0 : priceMin)
    // }
    barVolume.push(priceMin < 0 ? 0 : priceMin)
    barVolumeOffZero.push(priceMin < 0 ? 0 : priceMin)
  })
  return {
    priceArr: priceArr,
    lastPrice: lastPrice,
    vol: vol,
    times: times,
    datatype: datatype,
    avgPrice: avgPrice,
    startIndex: startIndex,
    index: index,
    barVolume: barVolume,
    barVolumeOffZero: barVolumeOffZero
  }
}

// ==========================================分时表 option

/**
 * 生成分时option
 * @param {Object} m_data 分时数据
 * @param {Object} type 股票类型  us-美股  hs-沪深  hk-港股
//  * @param {Object} echarts 图表对象 弃用
 * @param {Object} priceFixNum 价格小数位
 * @param {Object} quatityFixNum 数量小数位
 * @param {Object} dataZoom 监听记录用户滑动位置
 * @param {Object} useType 区分手机端K线/交易分时  mobile_k/mobile_t
 * @param {Object} toolboxMethods toolBox回调事件
 * @param {Object} low 跌停
 * @param {Object} high 涨停
 */
function initMOption(m_data, type, echarts = null, priceFixNum = 2, quatityFixNum = 2, dataZoom, useType, toolboxMethods, low, high) {
  if (type === 'white') {
    bgColor = '#fff'// 背景
    lastColor = '#FF0000'// 昨结
    lineColor = '#000'
    xyAxisColor = '#fff' // 轴线颜色
  } else {
    bgColor = '#000000'// 背景
    lastColor = '#FF0000'// 昨结
    lineColor = '#fff'
    xyAxisColor = '#000000' // 轴线颜色
  }
  let use_gri1_top = '5%'
  let use_gri1_height = '70%'
  let use_gri2_top = '75%'
  let use_gri2_height = '20%'
  // 判断是在使用位置动态调整大小
  if (useType === 'mobile_k') {
    // 手机k线
    use_gri1_top = '5%'
    use_gri1_height = '70%'
    use_gri2_top = '75%'
    use_gri2_height = '19%'
  } else if (useType === 'mobile_t') {
    // 交易分时
    use_gri1_top = '10%'
    use_gri1_height = '65%'
    use_gri2_top = '75%'
    use_gri2_height = '15%'
  }
  const m_datas = get_m_data(m_data, type, low, high)
  let priceMax = 0; let priceMin = null; let priceInterval = 0; let volumeMax = 0; const volumeMin = 0; let volumeInterval = 0
  let startValue = 0
  let endValue = 0
  // 控制刷新前后图表默认滑动位置相同
  // if (dataZoom && dataZoom?.startValue && dataZoom?.endValue) {
  //   startValue = dataZoom.startValue
  //   endValue = dataZoom.endValue
  // } else {
  //   // startValue = m_datas.startIndex
  //   startValue = 0
  //   endValue = m_datas.length
  // }
  // TODO 默认展示全部
  startValue = 0
  endValue = m_datas.length
  let lastPrice = Number(m_data.yestclose)
  if (lastPrice === 0) {
    lastPrice = (Number(high) + Number(low)) / 2
  }
  const UP_COLOR = upColor
  const DOWN_COLOR = downColor
  const NORMAL_COLOR = '#b0b8db'
  priceMin = m_data?.data && m_data.data.length > 0 ? m_data?.data[0][1] : 0
  for (const i in m_data.data) {
    if (Number(m_data.data[i][1]) && Number(m_data.data[i][1]) > priceMax) {
      priceMax = Number(m_data.data[i][1])
    }
    if (Number(m_data.data[i][1]) && Number(m_data.data[i][1]) < priceMin) {
      priceMin = Number(m_data.data[i][1])
    }
    if (Number(m_data.data[i][1]) && Number(m_data.data[i][3]) > volumeMax) {
      volumeMax = Number(m_data.data[i][3])
    }
  }
  // // 重新计算价格的最大最小值，以达到对称的效果
  // if ((lastPrice - priceMax) * -1 > (lastPrice - priceMin)) {
  //   priceMin = (lastPrice - ((lastPrice - priceMax) * -1))
  // } else {
  //   priceMax = (lastPrice + (lastPrice - priceMin))
  // }
  // 处理无交易情况,添加y轴范围
  if (Number(priceMin) === Number(priceMax) || Number(priceMin) === 0) {
    if (low && low !== '0.00' && high && high !== '0.00') {
      priceMin = Number(low)
      priceMax = Number(high)
    } else {
      priceMin = Number(lastPrice) - 10
      priceMax = Number(lastPrice) + 10
    }
    // 无交易的情况使用涨跌停价格处理y轴
    if (Number(low) && Number(priceMin) < Number(low)) {
      priceMin = Number(low)
    }
    if (Number(high) && Number(priceMax) > Number(high)) {
      priceMax = Number(high)
    }
  }
  // 重新计算价格的最大最小值，以达到对称的效果
  if ((lastPrice - priceMax) * -1 > (lastPrice - priceMin)) {
    priceMin = (lastPrice - ((lastPrice - priceMax) * -1))
  } else {
    priceMax = (lastPrice + (lastPrice - priceMin))
  }
  priceInterval = (priceMax - lastPrice) / 4
  volumeInterval = volumeMax / 2
  return {
    tooltip: { // 弹框指示器
      backgroundColor: '#000000aa',
      trigger: 'axis',
      axisPointer: {
        type: 'cross'
      },
      confine: true, // 限制弹窗不超出图表范围
      formatter: function(params, ticket, callback) {
        const i = params[0].dataIndex

        let color
        if (m_datas.priceArr[i] > m_data.yestclose) {
          color = `style="color:${upColor}"`
        } else {
          color = `style="color:${downColor}"`
        }

        let html = '<div class="commColor" style="width:100px;"><div>当前价 <span  ' + color + ' >' + Number(m_datas.priceArr[i]).toFixed(priceFixNum) + '</span></div>'
        html += '<div>昨结 <span  ' + color + ' >' + Number(m_datas.lastPrice[i]).toFixed(priceFixNum) + '</span></div>'
        html += '<div>均价 <span  ' + color + ' >' + Number(m_datas.avgPrice[i]).toFixed(priceFixNum) + '</span></div>'
        html += '<div>涨幅 <span  ' + color + ' >' + ratioCalculate(m_datas.priceArr[i], Number(m_datas.lastPrice[i])) + '</span></div>'
        html += '<div>成交量 <span  ' + color + ' >' + Number(m_datas.vol[i]).toFixed(quatityFixNum) + '</span></div></div>'
        // html += '<div>辅助线1 <span  ' + color + ' >' + m_datas.barVolume[i] + '</span></div></div>'
        // html += '<div>辅助线2 <span  ' + color + ' >' + m_datas.barVolumeOffZero[i] + '</span></div></div>'
        return m_datas.priceArr[i] ? html : ''
      }
    },
    legend: { // 图例控件,点击图例控制哪些系列不显示
      borderColor: '#FF0000',
      icon: 'rect',
      type: 'scroll',
      itemWidth: 14,
      itemHeight: 2,
      left: 25,
      top: '0%',
      textStyle: {
        fontSize: 12,
        color: '#0e99e2'
      }
    },
    axisPointer: {
      show: true,
      label: {
        show: false
      },
      lineStyle: {
        type: 'dotted'
      },
      link: [ // 指示器联动
        {
          xAxisIndex: [0, 1, 2]
        }
      ]
    },
    color: [lineColor, lastColor, ma5Color, ma10Color, downColor],
    grid: [{
      id: 'gd1',
      left: '35',
      right: '35',
      height: use_gri1_height, // 主K线的高度,
      top: use_gri1_top,
      z: 10,
      show: true,
      borderColor: '#FF0000',
      borderWidth: 1
    },
    {
      id: 'gd2',
      left: '35',
      right: '35',
      height: use_gri1_height, // 主K线的高度,
      top: use_gri1_top,
      z: 5
    },
    {
      id: 'gd3',
      left: '35',
      right: '35',
      top: use_gri2_top,
      height: use_gri2_height, // 交易量图的高度
      z: 1,
      show: true,
      borderColor: '#FF0000',
      borderWidth: 1
    }
    ],
    xAxis: [ // ==== x轴
      { // 主图
        axisTick: { show: false },
        boundaryGap: false, // 分割线与坐标刻度对齐
        gridIndex: 0,
        data: m_datas.times,
        axisLabel: { // label文字设置
          show: false,
          color: '#9b9da9',
          fontSize: 10,
          interval: 29, // 设置展示间隔
          formatter: function(value, index) {
            const title = value.slice(10, 16)
            return title
          }
        },
        splitLine: { // 分割线设置
          show: true,
          lineStyle: {
            color: '#ff000088',
            type: 'dotted' // 'dotted'虚线 'solid'实线
          }
        },
        axisLine: { // 纵轴样式
          lineStyle: {
            color: xyAxisColor
          }
        },
        axisPointer: {
          show: true,
          label: {
            show: false
          }
        }
      },
      {
        axisTick: { show: false },
        boundaryGap: false, // 分割线与坐标刻度对齐
        show: false,
        gridIndex: 1,
        data: m_datas.times,
        axisLabel: { // label文字设置
          show: false,
          color: '#9b9da9',
          fontSize: 10,
          interval: 29, // 设置展示间隔
          formatter: function(value, index) {
            const title = value.slice(10, 16)
            return title
          }
        },
        splitLine: { // 分割线设置
          show: true,
          lineStyle: {
            color: '#ff000088',
            type: 'dotted' // 'dotted'虚线 'solid'实线
          }
        },
        axisLine: { // 纵轴样式
          lineStyle: {
            color: xyAxisColor
          }
        },
        axisPointer: {
          show: false,
          label: {
            show: false
          }
        }
      },
      { // 交易量图
        axisTick: { show: false },
        boundaryGap: false, // 分割线与坐标刻度对齐
        splitNumber: 2,
        type: 'category',
        gridIndex: 2,
        data: m_datas.times,
        axisLine: { // 纵轴样式
          lineStyle: {
            color: xyAxisColor
          }
        },
        splitLine: { // 分割线设置
          show: true,
          lineStyle: {
            color: '#ff000088',
            type: 'dotted' // 'dotted'虚线 'solid'实线
          }
        },
        minorSplitLine: { // 次分割线
          show: true,
          lineStyle: {
            color: '#00ff0088',
            type: 'dotted' // 'dotted'虚线 'solid'实线
          }
        },
        axisLabel: { // label文字设置
          show: true,
          color: '#9b9da9',
          fontSize: 10,
          interval: 29, // 设置展示间隔
          formatter: function(value, index) {
            // let title = value.slice(10, 16)
            const title = value.slice(10, 16)
            // title = title.replace('13:00', '11:30/13:00')
            // title = title.replace('09:00', '15:30/09:00')
            return title
          }
        }
      }
    ],
    yAxis: [ // y轴
      // y轴左侧刻度线
      {
        // 去掉刻度值旁边的指示线
        axisTick: { show: false },
        splitNumber: 9,
        gridIndex: 0,
        interval: priceInterval,
        // scale: true,
        max: priceMax,
        min: priceMin,
        splitLine: { // 分割线设置
          lineStyle: {
            color: '#ff000088',
            type: 'dotted' // 'dotted'虚线 'solid'实线
          }
        },
        axisLine: { // 纵轴样式
          lineStyle: {
            color: xyAxisColor
          }
        },
        axisLabel: { // label文字设置
          fontSize: 10,
          margin: 0,
          // y轴的数值向内显示
          align: 'right',
          formatter: function(value, index) {
            let persent = (value - lastPrice) / lastPrice
            persent = (persent < 0) ? persent * -1 : persent
            persent = persent * 100

            return persent.toFixed(2) + '%'
          },
          color: function(value, index) {
            // 中间基准线的数值为灰色
            if (parseFloat(value).toFixed(2) == lastPrice) {
              return NORMAL_COLOR
            }
            // 上涨区域的数字为红色
            if (value > lastPrice) {
              return UP_COLOR
            }

            // 下方下跌的数值为绿色
            if (value < lastPrice) {
              return DOWN_COLOR
            }
          }
        },
        z: 3,
        axisPointer: { // y轴坐标轴指示器
          show: true,
          type: 'line',
          lineStyle: {
            type: 'dashed'
          },
          label: { // y轴左侧
            show: true,
            fontSize: 10,
            margin: 0,
            padding: 2,
            shadowBlur: 0,
            color: '#ffffff',
            formatter: function(data) {
              let persent = (data.value - lastPrice) / lastPrice
              persent = (persent < 0) ? persent * -1 : persent
              persent = persent * 100
              return persent.toFixed(2) + '%'
            }
          }
        }
      },
      // y轴右侧刻度线
      {
        axisTick: { show: false },
        splitNumber: 9,
        position: 'right',
        scale: true,
        interval: priceInterval,
        max: priceMax,
        min: priceMin,
        gridIndex: 1,
        splitLine: { // 分割线设置
          show: true,
          lineStyle: {
            color: '#ff0000',
            type: 'dotted' // 'dotted'虚线 'solid'实线
          }
        },
        axisLine: { // 纵轴样式
          lineStyle: {
            color: xyAxisColor
          }
        },
        axisLabel: {
          fontSize: 10,
          margin: 0,
          // y轴的数值向内显示
          align: 'left',
          formatter: function(value, index) {
            // return value.toFixed(priceFixNum)
            return value.toFixed(2)
          },
          // formatter: function(value, index) {
          //   let persent = (value - lastPrice) / lastPrice
          //   persent = (persent < 0) ? persent * -1 : persent
          //   persent = persent * 100

          //   return persent.toFixed(2) + '%'
          // },
          color: function(value, index) {
            // 中间基准线的数值为黑色
            if (parseFloat(value).toFixed(2) == lastPrice) {
              return NORMAL_COLOR
            }

            // 上涨区域的数字为红色
            if (value > lastPrice) {
              return UP_COLOR
            }

            // 下方下跌的数值为绿色
            if (value < lastPrice) {
              return DOWN_COLOR
            }
          }
        },
        axisPointer: { // y轴坐标轴指示器
          show: true,
          type: 'line',
          lineStyle: {
            type: 'dashed'
          },
          label: { // y轴左侧
            show: true,
            fontSize: 10,
            margin: 0,
            padding: 2,
            shadowBlur: 0,
            color: '#ffffff',
            formatter: function(data) {
              // return data.value.toFixed(priceFixNum)
              return data.value.toFixed(2)
            }
          }
        }
      },
      { // 交易图
        gridIndex: 2,
        z: 4,
        splitNumber: 2,
        axisLine: { // 纵轴样式
          show: false,
          onZero: false,
          lineStyle: {
            color: xyAxisColor
          }
        },
        axisTick: {
          show: false
        },
        splitLine: { // 分割线设置
          show: true,
          lineStyle: {
            color: '#ff000088',
            type: 'dotted' // 'dotted'虚线 'solid'实线
          }
        },
        axisLabel: { // label文字设置
          showMaxLabel: false, // 隐藏与百分比最小刻度重叠的刻度(解决与volume重叠的问题)
          color: '#c7c7c7',
          inside: false, // label文字朝内对齐
          fontSize: 8
        },
        axisPointer: { // y轴坐标轴指示器
          show: true,
          type: 'line',
          lineStyle: {
            type: 'dashed'
          },
          label: { // y轴左侧
            show: true,
            formatter: function(data) {
              return data.value.toFixed(quatityFixNum)
            }
          }
        }
      }
    ],
    dataZoom: [{
      type: 'inside',
      id: 'dataZoomLine',
      orient: 'horizontal', // 布局方式是横还是竖
      disabled: false, // 是否停止组件功能
      xAxisIndex: [0, 1, 2], // x轴,可以用数组表示多个轴
      throttle: 60, // 刷新频率
      startValue: startValue,
      endValue: endValue,
      zoomLock: true, // 只能平移
      zoomOnMouseWheel: false, // 禁止缩放
      minValueSpan: endValue - startValue, // 用于限制窗口大小的最小值（实际数值）。在类目轴上可以设置为 5 表示 5 个类目。
      maxValueSpan: endValue - startValue, // 用于限制窗口大小的最大值（实际数值）。
      moveOnMouseWheel: true,
      filterMode: 'weakFilter',
      start: null,
      end: null
    }],
    animation: false, // 禁止动画效果
    backgroundColor: bgColor,
    blendMode: 'source-over',
    series: [{
      name: '当前价',
      type: 'line',
      data: m_datas.priceArr,
      smooth: true,
      sampling: 'lttb', // 取过滤点的平均值
      symbol: 'none', // 是否显示折线上的小圆点
      lineStyle: {
        normal: {
          opacity: 1,
          color: lineColor,
          width: 1
        }
      },
      z: 10
      // areaStyle: { // 当前价的面积阴影
      //   normal: {
      //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      //       offset: 0,
      //       color: 'rgba(0, 136, 212, 0.7)'
      //     }, {
      //       offset: 0.8,
      //       color: 'rgba(0, 136, 212, 0.02)'
      //     }], false),
      //     shadowColor: 'rgba(0, 0, 0, 0.1)',
      //     shadowBlur: 10
      //   }
      // }
    },
    {
      name: '昨结',
      type: 'line',
      data: m_datas.lastPrice,
      smooth: true,
      sampling: 'lttb', // 取过滤点的平均值
      symbol: 'none',
      lineStyle: { // 标线的样式
        normal: {
          opacity: 1,
          color: lastColor,
          width: 1
        }
      },
      z: 8
    },
    {
      name: '均价',
      type: 'line',
      data: m_datas.avgPrice,
      smooth: true,
      sampling: 'lttb', // 取过滤点的平均值
      symbol: 'none',
      lineStyle: { // 标线的样式
        normal: {
          opacity: 1,
          width: 1
        }
      },
      z: 9
    },
    {
      type: 'line',
      data: m_datas.priceArr,
      smooth: true,
      sampling: 'lttb', // 取过滤点的平均值
      symbol: 'none',
      gridIndex: 1,
      xAxisIndex: 1,
      yAxisIndex: 1,
      lineStyle: { // 标线的样式
        normal: {
          width: 0
        }
      }
    },
    {
      name: 'Volumn',
      type: 'bar',
      gridIndex: 2,
      xAxisIndex: 2,
      yAxisIndex: 2,
      data: m_datas.vol,
      barWidth: '60%',
      itemStyle: {
        normal: {
          color: function(params) {
            let colorList
            if (m_datas.priceArr[params.dataIndex] > m_datas.priceArr[params.dataIndex - 1]) {
              colorList = upColor
            } else {
              colorList = downColor
            }
            return colorList
          }
        }
      }
    }
    // {
    //   // name: '分割线',
    //   gridIndex: 0,
    //   xAxisIndex: 0,
    //   yAxisIndex: 0,
    //   type: 'bar',
    //   data: m_datas.barVolume,
    //   smooth: true,
    //   symbol: 'none',
    //   lineStyle: { // 标线的样式
    //     normal: {
    //       opacity: 1,
    //       color: lastColor,
    //       width: 1
    //     }
    //   },
    //   z: 1,
    //   barWidth: 1,
    //   tooltip: {
    //     show: false
    //   },
    //   stack: 'bar_volume_line',
    //   label: {
    //     show: false,
    //     position: 'top',
    //     textStyle: {
    //       color: '#fff'
    //     }
    //   },
    //   itemStyle: {
    //     normal: {
    //       color: '#FF0000'
    //     }
    //   }
    // }
    // {
    //   // name: '分割线 处理小于0的问题',
    //   gridIndex: 0,
    //   xAxisIndex: 0,
    //   yAxisIndex: 0,
    //   type: 'bar',
    //   data: m_datas.barVolumeOffZero,
    //   smooth: true,
    //   symbol: 'none',
    //   lineStyle: { // 标线的样式
    //     normal: {
    //       opacity: 1,
    //       color: lastColor,
    //       width: 1
    //     }
    //   },
    //   z: 2,
    //   barWidth: 2,
    //   tooltip: {
    //     show: false
    //   },
    //   stack: 'bar_volume_line',
    //   label: {
    //     show: false,
    //     position: 'top',
    //     textStyle: {
    //       color: '#fff'
    //     }
    //   },
    //   itemStyle: {
    //     normal: {
    //       color: '#FF0000'
    //     }
    //   }
    // }
    ]
    // toolbox: {
    //   itemSize: 20,
    //   showTitle: false,
    //   feature: {
    //     myTool1: {
    //       show: true,
    //       title: '上一天',
    //       icon: 'image://https://download.gss.cn/upload/lastday.svg',
    //       onclick: function() {
    //         toolboxMethods('lastDay')
    //       }
    //     },
    //     myTool2: {
    //       show: true,
    //       title: '下一天',
    //       icon: 'image://https://download.gss.cn/upload/nextday.svg',
    //       onclick: function() {
    //         toolboxMethods('nextDay')
    //       }
    //     },
    //     myTool3: {
    //       show: true,
    //       title: '当天',
    //       icon: 'image://https://download.gss.cn/upload/current.svg',
    //       onclick: function() {
    //         toolboxMethods('today')
    //       }
    //     }
    //   }
    // }
  }
}

/**
 * 计算价格涨跌幅百分比
 * @param {Object} price 当前价
 * @param {Object} yclose 昨收价
 */
function ratioCalculate(price, yclose) {
  if (!price) {
    return ''
  }
  return ((price - yclose) / yclose * 100).toFixed(2) + '%'
}

// 数组处理
function splitData(rawData) {
  const datas = []; const times = []; const vols = []
  for (let i = 0; i < rawData.length; i++) {
    datas.push(rawData[i])
    times.push(rawData[i].splice(0, 1)[0])
    vols.push(rawData[i][4])
  }
  return { datas: datas, times: times, vols: vols }
}

// ================================MA计算公式
function calculateMA(dayCount, data) {
  const result = []
  for (let i = 0, len = data.times.length; i < len; i++) {
    if (i < dayCount) {
      result.push('-')
      continue
    }
    let sum = 0
    for (let j = 0; j < dayCount; j++) {
      sum += data.datas[i - j][1]
    }
    result.push((sum / dayCount).toFixed(2))
  }
  return result
}

// =================================================MADC计算公式

let calcEMA = null
let calcDIF = null
let calcDEA = null
let calcMACD = null

/*
 * 计算EMA指数平滑移动平均线，用于MACD
 * @param {number} n 时间窗口
 * @param {array} data 输入数据
 * @param {string} field 计算字段配置
 */
calcEMA = function(n, data, field) {
  const a = 2 / (n + 1)
  let ema = []
  if (field) {
    // 二维数组
    ema = [data[0][field]]
    for (let i = 1, l = data.length; i < l; i++) {
      ema.push((a * data[i][field] + (1 - a) * ema[i - 1]).toFixed(2))
    }
  } else {
    // 普通一维数组
    ema = [data[0]]
    for (let i = 1, l = data.length; i < l; i++) {
      ema.push((a * data[i] + (1 - a) * ema[i - 1]).toFixed(3))
    }
  }
  return ema
}

/*
 * 计算DIF快线，用于MACD
 * @param {number} short 快速EMA时间窗口
 * @param {number} long 慢速EMA时间窗口
 * @param {array} data 输入数据
 * @param {string} field 计算字段配置
 */
calcDIF = function(short, long, data, field) {
  const dif = []
  const emaShort = calcEMA(short, data, field)
  const emaLong = calcEMA(long, data, field)
  for (let i = 0, l = data.length; i < l; i++) {
    dif.push((emaShort[i] - emaLong[i]).toFixed(3))
  }
  return dif
}

/*
 * 计算DEA慢线，用于MACD
 * @param {number} mid 对dif的时间窗口
 * @param {array} dif 输入数据
 */
calcDEA = function(mid, dif) {
  return calcEMA(mid, dif)
}

/*
 * 计算MACD
 * @param {number} short 快速EMA时间窗口
 * @param {number} long 慢速EMA时间窗口
 * @param {number} mid dea时间窗口
 * @param {array} data 输入数据
 * @param {string} field 计算字段配置
 */
calcMACD = function(short, long, mid, data, field) {
  const result = {}
  const macd = []
  const dif = calcDIF(short, long, data, field)
  const dea = calcDEA(mid, dif)
  for (let i = 0, l = data.length; i < l; i++) {
    macd.push(((dif[i] - dea[i]) * 2).toFixed(3))
  }
  result.dif = dif
  result.dea = dea
  result.macd = macd
  return result
}

// =================================================MADC计算公式 end

function initKOption(cdata) {
  const data = splitData(cdata)
  const macd = calcMACD(12, 26, 9, data.datas, 1)
  return {
    tooltip: { // 弹框指示器
      trigger: 'axis',
      axisPointer: {
        type: 'cross'
      }
    },
    legend: { // 图例控件,点击图例控制哪些系列不显示
      icon: 'rect',
      type: 'scroll',
      itemWidth: 14,
      itemHeight: 2,
      left: 0,
      top: '-1%',
      animation: true,
      textStyle: {
        fontSize: 12,
        color: '#0e99e2'
      },
      pageIconColor: '#0e99e2'
    },
    axisPointer: {
      show: true
    },
    color: [ma5Color, ma10Color, ma20Color, ma30Color],
    grid: [{
      id: 'gd1',
      left: '0%',
      right: '1%',
      height: '60%', // 主K线的高度,
      top: '5%'
    }, {
      left: '0%',
      right: '1%',
      top: '66.5%',
      height: '10%' // 交易量图的高度
    }, {
      left: '0%',
      right: '1%',
      top: '80%', // MACD 指标
      height: '14%'
    }],
    xAxis: [ // ==== x轴
      { // 主图
        type: 'category',
        data: data.times,
        scale: true,
        boundaryGap: false,
        axisLine: {
          onZero: false
        },
        axisLabel: { // label文字设置
          show: false
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: '#3a3a3e'
          }
        },
        splitNumber: 20,
        min: 'dataMin',
        max: 'dataMax'
      }, { // 交易量图
        type: 'category',
        gridIndex: 1,
        data: data.times,
        axisLabel: { // label文字设置
          color: '#9b9da9',
          fontSize: 10
        }
      }, { // 幅图
        type: 'category',
        gridIndex: 2,
        data: data.times,
        axisLabel: {
          show: false
        }
      }
    ],
    yAxis: [ // y轴
      { // ==主图
        scale: true,
        z: 4,
        axisLabel: { // label文字设置
          color: '#c7c7c7',
          inside: true // label文字朝内对齐
        },
        splitLine: { // 分割线设置
          show: false,
          lineStyle: {
            color: '#181a23'
          }
        }
      }, { // 交易图
        gridIndex: 1, splitNumber: 3, z: 4,
        axisLine: {
          onZero: false
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisLabel: { // label文字设置
          color: '#c7c7c7',
          inside: true, // label文字朝内对齐
          fontSize: 8
        }
      }, { // 幅图
        z: 4, gridIndex: 2, splitNumber: 4,
        axisLine: {
          onZero: false
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisLabel: { // label文字设置
          color: '#c7c7c7',
          inside: true, // label文字朝内对齐
          fontSize: 8
        }
      }
    ],
    dataZoom: [{
      type: 'slider',
      xAxisIndex: [0, 1, 2], // 控件联动
      start: 100,
      end: 80,
      throttle: 100,
      top: '94%',
      height: '6%',
      borderColor: '#696969',
      textStyle: {
        color: '#dcdcdc'
      },
      handleSize: '90%', // 滑块图标
      handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
      dataBackground: {
        lineStyle: {
          color: '#fff'
        }, // 数据边界线样式
        areaStyle: {
          color: '#696969'
        } // 数据域填充样式
      }
    }
      // 		{
      // 			type: 'inside',
      // 			xAxisIndex: [0,1,2],//控件联动
      // 		},
    ],
    animation: true, // 禁止动画效果
    backgroundColor: bgColor,
    blendMode: 'source-over',
    series: [{
      name: 'K线周期图表',
      type: 'candlestick',
      data: data.datas,
      barWidth: '55%',
      large: true,
      largeThreshold: 100,
      itemStyle: {
        normal: {
          color: upColor, // fd2e2e  ff4242
          color0: downColor,
          borderColor: upColor,
          borderColor0: downColor

          // opacity:0.8
        }
      }

    }, {
      name: 'MA5',
      type: 'line',
      data: calculateMA(5, data),
      smooth: true,
      symbol: 'none', // 隐藏选中时有小圆点
      lineStyle: {
        normal: {
          opacity: 0.8,
          color: '#39afe6',
          width: 1
        }
      }
    },
    {
      name: 'MA10',
      type: 'line',
      data: calculateMA(10, data),
      smooth: true,
      symbol: 'none',
      lineStyle: { // 标线的样式
        normal: {
          opacity: 0.8,
          color: '#da6ee8',
          width: 1
        }
      }
    },
    {
      name: 'MA20',
      type: 'line',
      data: calculateMA(20, data),
      smooth: true,
      symbol: 'none',
      lineStyle: {
        opacity: 0.8,
        width: 1,
        color: ma20Color
      }
    },
    {
      name: 'MA30',
      type: 'line',
      data: calculateMA(30, data),
      smooth: true,
      symbol: 'none',
      lineStyle: {
        normal: {
          opacity: 0.8,
          width: 1,
          color: ma30Color
        }
      }
    }, {
      name: 'Volumn',
      type: 'bar',
      xAxisIndex: 1,
      yAxisIndex: 1,
      data: data.vols,
      barWidth: '60%',
      itemStyle: {
        normal: {
          color: function(params) {
            let colorList
            if (data.datas[params.dataIndex][1] > data.datas[params.dataIndex][0]) {
              colorList = upColor
            } else {
              colorList = downColor
            }
            return colorList
          }
        }
      }
    }, {
      name: 'MACD',
      type: 'bar',
      xAxisIndex: 2,
      yAxisIndex: 2,
      data: macd.macd,
      barWidth: '40%',
      itemStyle: {
        normal: {
          color: function(params) {
            let colorList
            if (params.data >= 0) {
              colorList = upColor
            } else {
              colorList = downColor
            }
            return colorList
          }
        }
      }
    }, {
      name: 'DIF',
      type: 'line',
      symbol: 'none',
      xAxisIndex: 2,
      yAxisIndex: 2,
      data: macd.dif,
      lineStyle: {
        normal: {
          color: '#da6ee8',
          width: 1
        }
      }
    }, {
      name: 'DEA',
      type: 'line',
      symbol: 'none',
      xAxisIndex: 2,
      yAxisIndex: 2,
      data: macd.dea,
      lineStyle: {
        normal: {
          opacity: 0.8,
          color: '#39afe6',
          width: 1
        }
      }
    }
    ]
  }
}

export default { initMOption }
